exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".insurance .select-wrapper select {\n  border: 1px solid #bdbdbd !important;\n  border-radius: 5px !important;\n  padding: 0 10px !important;\n  background: #fff !important;\n}\n.insurance-description p {\n  margin: 0;\n  text-align: start;\n}\n", ""]);

// exports
